import React from "react";
import values from "lodash/values";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import { Table, Sort } from "reactable";

import * as util from "../util";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";
import EditPersonOverlay from "./partials/overlays/edit-person.jsx";
import EventBucketStore from "../stores/EventBucketStore";

class People extends React.Component {
  constructor(props) {
    super(props);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.state = {
      page: 0
    };
  }

  static getStores() {
    return [PersonStore, UserStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        paddingTop: 20,
        marginTop: 20,
        borderTop: "1px solid #ccc"
      }
    };
  }

  _makeRowForPerson(eventBucket, person) {
    return {
      Person: person.details.name
        ? `${person.details.name} (${person.details.email})`
        : person.details.email,
      "Payment Method": person.details.payment_method_summary || "Not set",
      Actions: (
        <div>
          <Link
            to={
              eventBucket
                ? `/event_buckets/${eventBucket}/people/${person.id}`
                : `/people/${person.id}`
            }
          >
            View
          </Link>
        </div>
      )
    };
  }

  downloadCsv() {
    let people = values(this.props.people),
      eventBucket = this.props.params.eventBucketId;

    if (eventBucket) {
      people = people.filter(p => p.event_buckets.some(b => b === eventBucket));
    }

    let keys = [
      "id",
      "name",
      "email",
      "phone_number",
      "mailing_address",
      "facebook_user_id",
      "do_not_email",
      "payment_method_summary"
    ],
      peopleRows = people.map(p =>
        keys.map(k => (k === "id" ? p.id : p.details[k]))
      ),
      csvRows = [keys].concat(peopleRows);

    util.clientSideDownload(
      `people${eventBucket ? `-${eventBucket}` : ""}.csv`,
      "text/csv",
      util.makeCsv(csvRows)
    );
  }

  changePage(page) {
    this.setState({ page: page });
  }

  componentWillMount() {
    PersonActions.fetchAll();
  }

  render() {
    let styles = this.getStyles(),
      people = values(this.props.people),
      eventBucketId = this.props.params.eventBucketId,
      eventBucket = EventBucketStore.getEventBucketById(eventBucketId); // restrict to a single event bucket

    if (people.length === 0 && PersonStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    if (eventBucketId) {
      people = people.filter(p => p.event_buckets.some(b => b === eventBucketId));
    }

    const isSundance =
      UserStore.getUserId() === "632796a787711400538e66da" ||
      UserStore.getUserId() === "5dae0d7c41443700308287c5" ||
      (eventBucket && eventBucket.frontend_config && eventBucket.frontend_config.sundance_login);

    let rows = people.map(this._makeRowForPerson.bind(this, eventBucketId));

    return (
      <div>
        <h1 className="page-title">People</h1>
        {this.state.isCreating ? (
          <EditPersonOverlay
            onRequestClose={() => this.setState({ isCreating: false })}
            isNew={true}
            onEdit={(data, opts) => {
              if (opts && opts.existingId) {
                PersonActions.edit(opts.existingId, data);
              } else {
                PersonActions.create(
                  Object.assign(
                    data,
                    eventBucketId && { event_bucket: eventBucketId }
                  )
                );
              }
              this.setState({ isCreating: false });
            }}
          />
        ) : null}
        {UserStore.hasPermission("manage_people") && !isSundance ? (
          <div style={{ float: "right", marginBottom: -36 }}>
            <RaisedButton
              label="Create new person"
              onTouchTap={() => this.setState({ isCreating: true })}
            />
          </div>
        ) : null}
        <Table
          className="bordered striped responsive-table"
          data={rows}
          sortable={[
            { column: "Person", sortFunction: Sort.CaseInsensitive },
            "Payment Method"
          ]}
          defaultSort={{ column: "Person", direction: "asc" }}
          columns={["Person", "Payment Method", "Actions"]}
          filterable={["Person"]}
          filterPlaceholder="Type to filter..."
          itemsPerPage={rows.length && 50}
          currentPage={this.state.page}
          onPageChange={p => this.changePage(p)}
        />
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No people yet. People will automatically appear here once they place
            an order.
          </div>
        ) : null}
        {UserStore.hasPermission("manage_people") ? (
          <div style={styles.actions}>
            <RaisedButton onTouchTap={this.downloadCsv} label="Export CSV" />{" "}
            <RaisedButton
              style={{ marginLeft: 7 }}
              onTouchTap={() => this.context.router.push(`/bulk_import_people`)}
              label="Bulk import people"
            />
            <p>
              The exported CSV will contain all people
              {eventBucketId
                ? " who have placed an order in this event bucket"
                : ""}
              .
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(People);



// WEBPACK FOOTER //
// ./src/app/components/people.jsx